module.exports = "/assets/data/3d05896343ef621d2fdc85640c5b816c-LS23.data.json";